<div class="modal-header">
    <h3 ngbAutofocus class="modal-title" tabindex="-1">
        {{ titleLabel | translate }}
    </h3>

    <button class="modal-close" [attr.aria-label]="'misc.Close' | translate" (click)="closeModal()">
        <i class="icn-close"></i>
    </button>
</div>

<div class="modal-body" [innerHTML]="bodyContent">
</div>

<div class="modal-footer">
    <button class="btn btn_primary" (click)="closeModal()">
        {{ buttonLabel | translate }}
    </button>
</div>
